import { Segment, Header, Form } from 'semantic-ui-react';

export const InspectionFields = ({ groupedFields, fieldValues, fieldErrors, handleChange }) => (
  <>
    {Object.entries(groupedFields).map(([section, fields]) => (
      <div key={section} style={{ marginBottom: '1em' }}>
        <Segment>
          <Header as="h4">{section}</Header>
          {fields.map((field) => (
            <Form.Field key={field.index} required>
              <label>{field.name}</label>
              <Form.Select
                options={[
                  { key: 'pass', value: 'pass', text: 'Pass' },
                  { key: 'fail', value: 'fail', text: 'Fail' },
                  { key: 'na', value: 'na', text: 'N/A' },
                ]}
                value={field.value}
                onChange={(e, { value }) => handleChange(field.index, value)}
                error={fieldErrors[section] ? fieldErrors[section][field.field] : null}
              />
            </Form.Field>
          ))}
        </Segment>
      </div>
    ))}
  </>
);